import {Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from '@material-ui/core';
import React, {PureComponent} from 'react';
import {TransitionProps} from '@material-ui/core/transitions';
import Slide from '@material-ui/core/Slide';
import {localized} from '../../../../state/i18n/i18n';

interface PropsFromParent {
  callbackFromParent: (acceptStatus: boolean) => void;
}

interface State {
  open: boolean;
}
type Props = PropsFromParent;

const Transition = React.forwardRef(function PopUpTransition(
  props: TransitionProps & {children?: React.ReactElement<any, any>},
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export class DeviceManagementPopUp extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  handleClose = () => {
    this.setState({open: false});
  };

  callbackTrue = () => {
    this.callback(true);
  };

  callbackFalse = () => {
    this.callback(false);
  };

  callback = (response: boolean) => {
    this.props.callbackFromParent(response);
    this.handleClose();
  };

  public render() {
    return (
      <Dialog
        open={this.state.open}
        TransitionComponent={Transition}
        keepMounted={true}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title">{localized('UpdateCalibrationFactor')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">{localized('PopUpText')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.callbackFalse} color="primary">
            {localized('No')}
          </Button>
          <Button onClick={this.callbackTrue} color="primary">
            {localized('Yes')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DeviceManagementPopUp;
